import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '../../entity/product';

@Component({
  selector: 'product-selector',
  templateUrl: './product-selector.component.html'
})
export class ProductSelectorComponent {
  @Input() products: Product[];
  @Input() selectedProduct: Product;
  @Input() search: string;
  @Input() showButtons: boolean;
  @Output() onProductSelected = new EventEmitter<Product>(); 
  @Output() onFinishSelection = new EventEmitter();
  @Output() onCancelSelection = new EventEmitter();
  private selectionSearch: string;

  constructor()
  {
    this.products = new Array();
    this.selectionSearch = "";
    this.search = "";
  }

  ngOnInit(): void
  {
    //if(this.selectedProduct != null) {
      //this.selectionSearch = this.selectedProduct.label;
    //}    
  }
  
  public selectProduct(event: any, product: Product): void
  {
    if (this.selectedProduct!=null && this.selectedProduct.id == product.id) {
      //this.selectionSearch = "";
      this.onProductSelected.emit(null);
    } else {
      //this.selectionSearch = product.label;
      this.onProductSelected.emit(product);
    }    
  }

  public getFilterValue(): string
  {
    if (this.search.length>0) {
      return this.search.trim();
    } else {
      return this.selectionSearch;
    }
  }

  public trimSearch(): void
  {
    this.search = this.search.trim();
  }

  public finishSampleSelection(): void
  {
    
    this.onFinishSelection.emit();
    window.scroll(0,0);
  }

  public cancelSampleSelection(): void
  {
    this.onCancelSelection.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/order/product-selector/product-selector.component.ts